export default __webpack_public_path__ + "static/media/cog.98796d41.svg";